import React, { useContext, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import CustomDialog from '@/product/components/organisms/Dialog'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import CustomTable from '@/product/components/molecules/CustomTable'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import ProductContext from '@/product/context/product/productContext'
import BidContext from '@/product/context/bid/bidContext'
import CommonContext from '@/product/context/common/commonContext'
import ReportContext from '@/product/context/report/reportContext'
import AuthContext from '@/product/context/auth/authContext'

import { handleRedirectInternal, mapData } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import BidHistory from '@/custom/components/organisms/BidHistory/CustomBidHistory'

const UserBidHistory = (props) => {
    const productContext = useContext(ProductContext)
    const bidContext = useContext(BidContext)
    const authContext = useContext(AuthContext)

    const { user } = authContext

    const {
        search_allbidhistory,
        getAllBidHistory,
        clearResponse: clearAllBidHistory,
    } = productContext
    const { bidCancel, responseStatus: responseStatusBid } = bidContext

    const history = useHistory()
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const commonContext = useContext(CommonContext)
    const { bidHistoryValue, setBidHistoryValue, clearBidHistoryValue } =
        commonContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [tableBody, setTableBody] = useState([])

    const [allBidHistory, setAllBidHistory] = useState([])

    const [data, setData] = useState({
        popup: false,
        status: 'new',
        id: 0,
        project_id: 0,
        proxy: true,
        delete_bid: user?.emp_type === 'super_admin' ? true : false,
        user_id: 0,
        noApiCall: true,
        from: 'UserProjectBidHistory',
    })

    const [showDeclined, setShowDeclined] = useState(false)
    const toggleDecline = () => {
        formikData.values.page = 1
        setShowDeclined(!showDeclined)
        formikData.values.declined = !showDeclined
        getAllBidHistory(formikData.values, 'UserBidHistory')
    }

    const onClickEdit = (id, secondaryID, type) => {
        formikSelection.values.action = type
        formikSelection.values.id = id
        formikSelection.values.pid = formikData.values.filters.project_id.value
        if (type === 'delete') {
            setChangeStatus(true)
        } else if (type === 'bidcount') {
            setData({
                id: secondaryID,
                project_id: secondaryID,
                proxy: true,
                delete_bid: user?.emp_type === 'super_admin' ? true : false,
                user_id: props.userId,
                noApiCall: true,
                offer: true,
                status: 'new',
                popup: true,
                from: 'UserProjectBidHistory',
            })
        }
    }

    const formikData = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            declined: false,
            delete_bid: false,
            show_declined: false,
            project: 'NPS',
            get_bid_project: true,
            filters: {
                project_id: {
                    value: '',
                    type: 'in',
                    field: 'b.project_id',
                },
                user_id: {
                    value: props.userId,
                    type: 'in',
                    field: 'b.user_id',
                },
                proposal: {
                    value: 'tie_bid',
                    type: 'notin',
                    field: 'b.proposal',
                },
                auctionid: {
                    field: 'p.auctionid',
                    value: '',
                    type: 'in',
                },
                market_status: {
                    field: 'p.market_status',
                    type: 'arrayinmultiple',
                    value: '',
                },
            },
        },
        onSubmit: (values) => {
            getCreditHistory(values)
        },
    })

    useEffect(() => {
        formikData.values.filters.user_id.value = props?.userId
        getAllBidHistory(formikData.values, 'UserBidHistory')

        return () => {
            clearBidHistoryValue()
        }
    }, [bidHistoryValue])

    useEffect(() => {
        if (search_allbidhistory.from === 'UserBidHistory') {
            if (search_allbidhistory.records.length) {
                search_allbidhistory.records.map((item) => {
                    if (item.bidtopstatus) {
                        item.bidtopstatus =
                            item.bidtopstatus == 'lost'
                                ? 'Lost'
                                : item.bidtopstatus == 'won'
                                  ? 'Won'
                                  : item.bidtopstatus == 'winner'
                                    ? 'Winning'
                                    : item.bidtopstatus == 'outbid'
                                      ? 'Currently Outbid'
                                      : 'No Bids'
                    }
                })

                setTableBody(search_allbidhistory.records)
            } else {
                setTableBody([])
                //setTableBody(search_allbidhistory.records.length ? search_allbidhistory.records : [])
            }
            setAllBidHistory(search_allbidhistory)
        }
    }, [search_allbidhistory])

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'history',
            clickType: 'bidcount',
            clickID: 'id',
            secondaryClickID: 'projects_id',
            onclick: onClickEdit,
            tooltipTitle: 'Bid History',
            showInMenu: false,
        })

        return actionPush
    }

    const onClickPreview = (id, secondaryID, type) => {
        handleRedirectInternal(history, `listing/edit/${id}`)
    }

    let tableValues = [
        {
            field: 'projects_id',
            type: '',
            firstChild: true,
            sort: true,
            sortField: 'p.id',
            disablePadding: false,
            label: 'Lot #',
            filterable: true,
            filterField: 'p.id',
        },
        {
            field: 'projects_avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
            custom: true,
        },
        {
            field: 'projects_title',
            type: 'hyperlink',
            click: true,
            clickID: 'projects_id',
            onclick: onClickPreview,
            firstChild: false,
            sort: 1,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Title',
            filterable: true,
            filterField: 'p.title',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Date',
        },
    ]

    if (formikData.values.declined) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'declined',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Retracted',
                },
                false: {
                    type: 'text',
                    value: 'Valid',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        })
        tableValues.push({
            field: 'bid_retract_logs_created_at',
            type: 'datetime',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Retracted On',
        })
        tableValues.push({
            field: 'brl_first_name,brl_last_name',
            type: 'text',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Retracted By',
        })
    }

    if (formikData.values.get_proxy) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'proxytable',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Max',
                },
                false: {
                    type: 'value',
                    value: 'bidText',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Type',
        })
    }

    tableValues.push({
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Amount',
    })

    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        tableValues = global.additionalBidHistory
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: '',
            pid: '',
        },
        onSubmit: (values) => {
            if (values.action === 'delete') {
                // setIsLoading(true)
                bidCancel(values, 'UserBidCancel')
            }
        },
    })

    tableValues.push({
        field: 'action',
        type: 'button',
        isMultiple: true,
        clickID: 'id',
        secondaryClickID: 'projects_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    if (formikData.values.delete_bid && !showDeclined) {
        tableValues.push({
            field: 'action',
            type: 'button',
            clickType: 'delete',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Delete Bid',
            buttonType: 'delete',
        })
    }

    useEffect(() => {
        if (responseStatusBid) {
            if (responseStatusBid.from === 'UserBidCancel') {
                if (responseStatusBid.status === 'success') {
                    // changeChangeStatus()
                    setChangeStatus(false)
                    getAllBidHistory(formikData.values, 'UserBidHistory')
                }
            }
        }
    }, [responseStatusBid])

    const tableActions = []

    let warHouse = []
    let warHouseExport = {}
    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        global.additionalBidHistory.map((spaceDog) => {
            warHouse.push({
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            })
            warHouseExport[spaceDog.field] = {
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            }
        })
    }

    return (
        <>
            <div className="">
                <Button
                    id="bid_history"
                    onClick={() =>
                        getAllExportDownload({
                            action: 'export',
                            order: 'asc',
                            orderby: '',
                            search: formikData.values.get_bid_auction
                                ? `p.auctionid=${formikData.values.filters.auctionid.value}`
                                : `b.project_id=${formikData.values.filters.project_id.value}`,
                            report: `bid_history`,
                            get_bid_auction: formikData.values.get_bid_auction
                                ? true
                                : false,
                            report_action: formikData.values.get_bid_auction
                                ? 'download'
                                : '',
                            fields: warHouseExport,
                            market_status:
                                formikData.values.filters.market_status.value,
                        })
                    }
                >
                    {' '}
                    <span className="material-icons">get_app</span>Export All
                    Data
                </Button>

                {formikData.values.show_declined ? (
                    <div className="text-right">
                        <FormControlLabel
                            id={'show_declined'}
                            label={'Show Retracted'}
                            control={
                                <Switch
                                    checked={showDeclined}
                                    onChange={toggleDecline}
                                />
                            }
                        />
                    </div>
                ) : null}

                <CustomTable
                    formik={formikData.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={allBidHistory}
                    changeTableFunction={getAllBidHistory}
                    fromVariable="UserBidHistory"
                />
            </div>
            <CustomDialog
                title={'Change Bid Status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete the bid ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="bidHistory_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="bidHistory_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            <BidHistory
                project={props.project}
                data={data}
                formik={formikData}
                fromVariable={'UserBidHistory'}
            />
        </>
    )
}

export default UserBidHistory
